module.exports = __webpack_public_path__ + "img/home6.4ec54c93.png";